<template>
    <ModalBase @close="cancel" :withContent="true" v-show="visible">
        <b-card>
            <label>
                <h3>{{ trads.label }}</h3>
            </label>
            <b-container fluid>
                <b-row>
                    <b-col sm="4">
                        <label>{{ trads.width }}</label>
                    </b-col>
                    <b-col sm="8"> <b-form-input type="number" v-model="width"></b-form-input> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4">
                        <label>{{ trads.direction.label }}</label>
                    </b-col>
                    <b-col sm="8">
                        <select v-model="direction">
                            <option value="left">{{ trads.direction.left }}</option>
                            <option value="center">{{ trads.direction.center }}</option>
                            <option value="right">{{ trads.direction.right }}</option>
                        </select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4">
                        <label>{{ trads.height }}</label>
                    </b-col>
                    <b-col sm="8"> <b-form-input type="number" v-model="height"></b-form-input> </b-col>
                </b-row>
            </b-container>
            <b-button-toolbar>
                <b-button style="margin:5px;" variant="primary" @click="validate();">{{ trads.ok }}</b-button>
                <b-button style="margin:5px;" @click="cancel();">{{ trads.cancel }}</b-button>
            </b-button-toolbar>
        </b-card>
    </ModalBase>
</template>

<script>
import ModalBase from "@/components/modal/ModalBase";

let editBoardPaperWidget;
window.editPaper = function editPaper(data, onValidate, onCancel) {
    editBoardPaperWidget.width = data.width;
    editBoardPaperWidget.height = data.height;
    editBoardPaperWidget.visible = true;
    editBoardPaperWidget.onValidate = onValidate;
    editBoardPaperWidget.onCancel = onCancel;
};

export default {
    components: { ModalBase },
    data: () => ({
        width: 0,
        height: 0,
        direction: "right",
        fixed: false,
        visible: false,
        onValidate: undefined,
        onCancel: undefined
    }),
    created() {
        editBoardPaperWidget = this;
    },
    methods: {
        validate() {
            this.onValidate({
                width: parseInt(this.width),
                height: parseInt(this.height),
                direction: this.direction,
                fixed: this.fixed
            });
            this.visible = false;
        },
        cancel() {
            this.onCancel();
            this.visible = false;
        }
    },
    computed: {
        trads() {
            return this.$trad.plano.editor.resizePaper;
        }
    }
};
</script>



// WEBPACK FOOTER //
// edit_paper.vue?7ab37a95